import { useLayoutEffect, useState } from 'react';

enum ScreenSize {
	Mobile = 'Mobile'
}

const checkScreenSize = () => window.innerWidth <= 800;

export default function useScreenSize() {
	const [isMobile, setIsMobile] = useState<boolean>(checkScreenSize);

	useLayoutEffect(() => {
		const resize = () => {
			setIsMobile(checkScreenSize);
		};

		window.addEventListener('resize', resize);
		window.addEventListener('orientationchange', resize);
		window.addEventListener('load', resize);
		window.addEventListener('reload', resize);

		return () => {
			window.removeEventListener('resize', resize);
			window.removeEventListener('orientationchange', resize);
			window.removeEventListener('load', resize);
			window.removeEventListener('reload', resize);
		};
	}, [setIsMobile]);

	return isMobile;
}
